import { ICompareInChartMinimal } from "@/api";
import { useOrganizationProxy } from "@/hooks/useOrganizationProxy";
import { Link } from "@mui/material";

interface IProps {
    comparison: ICompareInChartMinimal;
}

export const ComparisonLink = ({ comparison }: IProps) => {
    const { proxyIntoOrganization, isPending } = useOrganizationProxy({
        navigationPath: `/organizations/comparisons/${comparison.id}`,
    });

    return (
        <Link
            component="button"
            onClick={() => proxyIntoOrganization(comparison.organization_id)}
            disabled={isPending}
        >
            {comparison.name}
        </Link>
    );
};
